import React, { useState, useEffect } from 'react';
import * as Styled from '../Dashboard.styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Card from '../../../components/Card/Card';
import { dailyMovementsFetchAction } from '../../../store/fetchActions/dailyMovementsActions';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from '../../../styles/theme';
import SaldoContaDigital from '../../../assets/icon/SaldoContaDigital';
import { balancesFetchAction } from '../../../store/fetchActions/balancesActions';
import { useLocation } from 'react-router-dom';
import { getSaldoAdminFetchAction } from '../../../store/fetchActions/getSaldoAdmin';
import { getSaldoGeralFetchAction } from '../../../store/fetchActions/getSaldoGeral';

const { mainColor, secondaryColor } = theme.colors;

export default function CardContainer() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);
  const cpfcnpj = localStorage.getItem('cpfcnpj');

  useEffect(() => {
    const listMovements = () =>
      dispatch(dailyMovementsFetchAction({ limit: 10, page: 1 }));
    listMovements();
    dispatch(getSaldoGeralFetchAction());
    dispatch(getSaldoAdminFetchAction());
    if (location !== '/login') dispatch(balancesFetchAction(cpfcnpj));
  }, [dispatch, location]);

  const extendedHeight = '29vw';
  const contractedHeight = '11vw';

  const { dataSaldoAdmin } = useSelector((state) => state.saldoAdmin);
  const { dataSaldoGeral } = useSelector((state) => state.saldoGeral);

  const {
    TOTAL_AVULSO_CREDITO,
    TOTAL_AVULSO_DEBITO,
    TOTAL_CREDITO,
    TOTAL_DEBITO,
    TOTAL_DEPOSITO,
    TOTAL_EMPRESTIMO,
    TOTAL_PAGAMENTO,
    TOTAL_PIX,
    TOTAL_TARIFAS,
    TOTAL_QRCODE_CREDITO,
    TOTAL_QRCODE_DEBITO,
    TOTAL_CARTAO_DEBITO,
    TOTAL_SAQUE_PDV_CREDITO,
    TOTAL_TRANSACAO_INTERNA_CREDITO,
    TOTAL_TRANSACAO_INTERNA_DEBITO,
    TOTAL_RECARGAS,
  } = useSelector((state) => state.dailyMovements);

  return (
    <Styled.CardContainer>
      <Styled.CardElement>
        <Card
          icon={<AttachMoneyIcon />}
          iconColor={'#DF33D6'}
          backgroundColorContainer={'rgba(223, 51, 214, 0.2)'}
          expandedHeight={extendedHeight}
          height={contractedHeight}
          name="Banco"
          text="Saldo disponível"
          value={dataSaldoAdmin.SALDO}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          data={[
            {
              name: 'Data',
              value: dataSaldoAdmin?.DATA,
            },
            {
              name: 'Hora',
              value: dataSaldoAdmin?.HORA,
            },
          ]}
          color={'#DF33D6'}
        />
      </Styled.CardElement>
      <Styled.CardElement>
        <Card
          icon={<ArrowDownwardIcon />}
          iconColor={secondaryColor}
          backgroundColorContainer={'#1014101A'}
          expandedHeight={extendedHeight}
          height={contractedHeight}
          name="Crédito"
          text="Valor total"
          value={TOTAL_CREDITO}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          data={[
            {
              name: 'Boletos',
              value: TOTAL_DEPOSITO,
            },
            {
              name: 'Empréstimos',
              value: TOTAL_EMPRESTIMO,
            },
            {
              name: 'QR Code',
              value: TOTAL_QRCODE_CREDITO,
            },
            {
              name: 'Crédito Avulso',
              value: TOTAL_AVULSO_CREDITO,
            },
            {
              name: 'Tarifa',
              value: TOTAL_TARIFAS,
            },
            {
              name: 'Saque PDV',
              value: TOTAL_SAQUE_PDV_CREDITO,
            },
            {
              name: 'Transferência entre Contas',
              value: TOTAL_TRANSACAO_INTERNA_CREDITO,
            },
          ]}
          color={secondaryColor}
        />
      </Styled.CardElement>
      <Styled.CardElement>
        <Card
          icon={<ArrowUpwardIcon />}
          iconColor={mainColor}
          backgroundColorContainer={'rgba(255, 85, 126, 0.2)'}
          expandedHeight={extendedHeight}
          height={contractedHeight}
          name="Débito"
          text="Valor total"
          value={TOTAL_DEBITO}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          data={[
            {
              name: 'Cartões',
              value: TOTAL_CARTAO_DEBITO,
            },
            {
              name: 'Pagamentos',
              value: TOTAL_PAGAMENTO,
            },
            {
              name: 'Transferências',
              value: TOTAL_PIX,
            },
            {
              name: 'QR Code',
              value: TOTAL_QRCODE_DEBITO,
            },
            {
              name: 'Débito Avulso',
              value: TOTAL_AVULSO_DEBITO,
            },
            {
              name: 'Transferência entre Contas',
              value: TOTAL_TRANSACAO_INTERNA_DEBITO,
            },
            {
              name: 'Recarga de Celular',
              value: TOTAL_RECARGAS,
            },
          ]}
          color={mainColor}
        />
      </Styled.CardElement>
      <Styled.CardElement>
        <Card
          icon={<SaldoContaDigital />}
          iconColor={mainColor}
          backgroundColorContainer={'rgba(112, 168, 249, 0.2)'}
          expandedHeight={extendedHeight}
          height={contractedHeight}
          name="Saldo Conta Digital"
          text="Saldo do dia"
          value={dataSaldoGeral}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          color={'rgba(112, 168, 249, 1)'}
        />
      </Styled.CardElement>
    </Styled.CardContainer>
  );
}
